export { default } from './ModalRestaurant';
